import { SidebarPopoverIndicatorWrapper } from './styles';

export function SidebarPopoverIndicator() {
  return (
    <SidebarPopoverIndicatorWrapper
      width="4"
      height="5"
      viewBox="0 0 4 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0.75C0 0.08 0.80 -0.25 1.28 0.22L3 1.94C3.3 2.23 3.3 2.71 3 3L1.28 4.73C0.8 5.2 0 4.87 0 4.2V0.75Z"
        fill="currentColor"
      />
    </SidebarPopoverIndicatorWrapper>
  );
}
